import React, { useState, useEffect } from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import InputMask from "react-input-mask";
import BaseSelect from 'components/baseSelect';
import { string } from 'yup';

const ReferenceForm = ({errors, touched, handleChange, values, element, removeReferenceForm, options, onReferenceTypeChange}) => {
    const onRemoveForm = () => removeReferenceForm(element.id);
    const [relacionPersonal, setRelacionPersonal] = useState(false);
    const [relacionLaboral, setRelacionLaboral] = useState(false);
    const [isFisrtTime, setIsFirstTime] = useState(true);

    useEffect(() => {
        if (!isFisrtTime) {
            values[`parentescoId_${element.id}`] = null;
        }

        if (onReferenceTypeChange) {
            onReferenceTypeChange();
        }
        
        if (values[`referenceType_${element.id}`] == "1") {
            setRelacionPersonal(true);
            setRelacionLaboral(false);
        } else {
            setRelacionLaboral(true);
            setRelacionPersonal(false);
        }
        
        setIsFirstTime(false);

    }, [values[`referenceType_${element.id}`]])

    return (
        <>
            <Form.Group as={Col} md="4" controlId={"validationreferenceType_" + element.id}>
                <Form.Label> Tipo de referencia *</Form.Label>
                <Form.Control
                    name={`referenceType_${element.id}`}
                    value={values[`referenceType_${element.id}`]}
                    onChange={handleChange}
                    //isValid={touched[`referenceType_${element.id}`] && !errors[`referenceType_${element.id}`]}
                    isInvalid={!!errors[`referenceType_${element.id}`]}
                    as="select"
                    custom
                >
                    {
                        options.map(option => {
                            return (
                                <option key={option.value} value={option.value}>{option.label}</option>
                            )
                        })
                    }
                </Form.Control>
            </Form.Group>

            {/* <BaseSelect
                md={6}
                errors={errors}
                touched={touched}
                handleChange={handleChange}
                values={values}
                label={'Profesión *'}
                name={`position_${element.id}`}
                url={'Profesion'}
            /> */}
            
            <Form.Group as={Col} md="4" controlId={"validationNames_" + element.id}>
                <Form.Label>Nombres *</Form.Label>
                <Form.Control
                    type="text"
                    name={`names_${element.id}`}
                    placeholder="Pedro José"
                    value={values[`names_${element.id}`]}
                    onChange={handleChange}
                    //isValid={touched[`names_${element.id}`] && !errors[`names_${element.id}`]}
                    isInvalid={!!errors[`names_${element.id}`]}
                />
                <Form.Control.Feedback type="invalid">
                    {errors[`names_${element.id}`]}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} md="4" controlId={"validationLastNames_" + element.id}>
                <Form.Label>Apellidos *</Form.Label>
                <Form.Control
                    type="text"
                    name={`lastNames_${element.id}`}
                    placeholder="Romero Fuentes"
                    value={values[`lastNames_${element.id}`]}
                    onChange={handleChange}
                    //isValid={touched[`lastNames_${element.id}`] && !errors[`lastNames_${element.id}`]}
                    isInvalid={!!errors[`lastNames_${element.id}`]}
                />
                <Form.Control.Feedback type="invalid">
                    {errors[`lastNames_${element.id}`]}
                </Form.Control.Feedback>
            </Form.Group>
            
            {
                relacionLaboral &&
                <BaseSelect
                    md={4}
                    errors={errors}
                    touched={touched}
                    handleChange={handleChange}
                    values={values}
                    label={'Relación *'}
                    name={`parentescoId_${element.id}`}
                    url={'Parentesco?$filter=Laboral eq 0'}
                />
            }

            {
                relacionPersonal &&
                <BaseSelect
                    md={4}
                    errors={errors}
                    touched={touched}
                    handleChange={handleChange}
                    values={values}
                    label={'Relación *'}
                    name={`parentescoId_${element.id}`}
                    url={'Parentesco?$filter=Laboral eq 1'}
                />
            }
            

            <Form.Group as={Col} md="4" controlId={"validationcompany_" + element.id}>
                <Form.Label>Empresa</Form.Label>
                <Form.Control
                    type="text"
                    name={`company_${element.id}`}
                    placeholder="Asociación, grupo..."
                    value={values[`company_${element.id}`]}
                    onChange={handleChange}
                    //isValid={touched[`company_${element.id}`] && !errors[`company_${element.id}`]}
                    isInvalid={!!errors[`company_${element.id}`]}
                />
                <Form.Control.Feedback type="invalid">
                    {errors[`company_${element.id}`]}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} md="4" controlId={"validationphone_" + element.id}>
                <Form.Label>Teléfono *</Form.Label>
                <Form.Control
                    type="text"
                    name={`phone_${element.id}`}
                    placeholder="(829) 000-0000"
                    as={InputMask}
                    mask="(999) 999-9999"
                    value={values[`phone_${element.id}`]}
                    onChange={handleChange}
                    //isValid={touched[`phone_${element.id}`] && !errors[`phone_${element.id}`]}
                    isInvalid={!!errors[`phone_${element.id}`]}
                />
                <Form.Control.Feedback type="invalid">
                    {errors[`phone_${element.id}`]}
                </Form.Control.Feedback>
            </Form.Group>
            
            

            <Form.Group as={Col} md="12">
                <Button onClick={onRemoveForm} variant="outline-primary"><i className="fas fa-trash-alt"></i></Button>
            </Form.Group>
        </>
    )
}

export default ReferenceForm;